import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/template/${number | ':templateId'}/setToJob`;

export const ROUTE: RouteDefinition = `${baseRoute}/template/:templateId/setToJob`;

export const URL = (templateId: number): RouteDefinition => `${baseRoute}/template/${templateId}/setToJob`;
